import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "an-home-building",
  "use": "an-home-building-usage",
  "viewBox": "0 0 37 26",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37 26\" id=\"an-home-building\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.668 9.1l-8.7-3.4V0h-4v4.2l-10.3-4c-.7-.3-1.5-.2-2 .3l-9 8c-.8.7-.9 2-.2 2.8.4.5.9.7 1.5.7h1v14h6V14h6v12h18V13h1c.8 0 1.6-.5 1.9-1.3.4-1-.1-2.2-1.2-2.6zm-5.7 4.9v3h-4v-3h4zm-10 0h4v3h-4v-3zm0 8v-3h4v3h-4zm10 0h-4v-3h4v3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol